'use strict';

var getBreakpoints = require('./getBreakpoints');

function getCol(opts) {

  var className = opts.breakpoints ? getBreakpoints(opts.breakpoints) : null;

  return {
    tag: 'div',
    attrs: {
      className: className
    },
    children: opts.children
  };
}

module.exports = getCol;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getCol.js
 ** module id = 1065
 ** module chunks = 0
 **/